import { PageResponse } from '@omnia/ui/src/lib'
import type { HeroCarouselPropsApi } from '@/common/components/heroCarousel/models'
import type { CurzonGridRow } from '@/features/grid/grid.types'

export class HomePageResponse extends PageResponse {
    public grid: CurzonGridRow[]
    public components = {
        HeroCarousel: new Array<HeroCarouselPropsApi>(),
    }
}
